/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Confirm_NoteInputs */

const cs_ebr_confirm_note = /** @type {(inputs: Ebr_Confirm_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import použije přesně tento náhled. Položky, které se mezitím změnily, přeskočí.`)
};

const en_ebr_confirm_note = /** @type {(inputs: Ebr_Confirm_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The import applies exactly this preview. Items that changed meanwhile are skipped.`)
};

/**
* | output |
* | --- |
* | "The import applies exactly this preview. Items that changed meanwhile are skipped." |
*
* @param {Ebr_Confirm_NoteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_confirm_note = /** @type {((inputs?: Ebr_Confirm_NoteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Confirm_NoteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_confirm_note(inputs)
	return cs_ebr_confirm_note(inputs)
});